var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navBox"},[_c('div',{staticClass:"navBoxCenter"},[_c('img',{staticStyle:{"width":"123px","height":"44px"},attrs:{"src":require("../assets/img/logo.png")}}),_c('div',{staticClass:"skipBoxfather"},[_c('skipBar')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }